import { render, staticRenderFns } from "./DialogOtp.vue?vue&type=template&id=54521825&lang=pug"
import script from "./DialogOtp.vue?vue&type=script&lang=js"
export * from "./DialogOtp.vue?vue&type=script&lang=js"
import style0 from "./DialogOtp.vue?vue&type=style&index=0&id=54521825&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports